/* GA4 events for the empty cart drawer. Markup: snippets/src-cart-empty.liquid. */
(function () {
  if (window.__srcCartEmptyTracking) return;
  window.__srcCartEmptyTracking = true;

  var GA4_ID = 'G-Y0VT2QGQW7';

  function gtag() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function track(name, empty, params) {
    var payload = {
      send_to: GA4_ID,
      site_market: empty.getAttribute('data-market'),
      page_type: empty.getAttribute('data-page-type')
    };
    for (var k in params) payload[k] = params[k];
    gtag('event', name, payload);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-src-cart-empty-cta], [data-src-cart-empty-quiz]');
    if (!link) return;
    var empty = link.closest('[data-src-cart-empty]');
    if (!empty) return;
    track(link.hasAttribute('data-src-cart-empty-cta') ? 'src_cart_empty_cta' : 'src_cart_empty_quiz', empty, {
      link_url: link.href,
      link_text: link.textContent.replace(/\s+/g, ' ').trim(),
      transport_type: 'beacon'
    });
  });

  var drawer = document.querySelector('.kozler-cart[data-section-id]');
  if (!drawer || typeof MutationObserver === 'undefined') return;

  // One view per drawer opening, including when the last item is removed while open.
  var viewed = false;
  function check() {
    if (!drawer.classList.contains('is-open')) {
      viewed = false;
      return;
    }
    if (viewed) return;
    var empty = drawer.querySelector('[data-src-cart-empty]');
    if (!empty) return;
    viewed = true;
    track('src_cart_empty_view', empty, {});
  }

  new MutationObserver(check).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
  check();
})();
